import api from '../api';
import { ENDPOINTS } from '../../constants/apiEndpoints';

export const fetchTermDepositUrl = () => {
  return api.get(ENDPOINTS.fetch_term_deposits.url);
};

export const createTermDepositUrl = (payload) => {
  return api.post(ENDPOINTS.create_term_deposits.url, payload);
};

export const createTermDepositInterestUrl = (payload) => {
  return api.post(ENDPOINTS.create_term_depositInterest.url, payload);
};

export const fetchTermDepositInterestUrl = (parentId) => {
  return api.get(ENDPOINTS.fetch_term_deposit_interest.url.replace('{parentId}', parentId));
};

export const createTermDepositPreMatureInterestUrl = (payload) => {
  return api.post(ENDPOINTS.create_term_deposit_pre_mature_interest.url, payload);
};

export const fetchTermDepositInterestPreMatureUrl = (parentId) => {
  return api.get(ENDPOINTS.fetch_term_deposit_interest_premature.url.replace('{parentId}', parentId));
};
